import "./FoodItem.css";
import bin from "../../Assets/Icons/recycle-bin.png";

export default function QuantityControl({
  mode,
  value,
  onIncrease,
  onDecrease,
  hideTitle = false,
  type = "default",
  handleDeleteItem,
  selectedItemInCart,
}) {
  return (
    <div className={`quantity-wrapper ${type}`}>
      {!hideTitle && <p className='quantity-label'>Quantity</p>}
      <div
        className={`quantity-control ${type === "addon" ? "addon-style" : ""}`}
      >
        {value === 0 ? (
          <button className='circle-btn addon-initial-btn' onClick={onIncrease}>
            +
          </button>
        ) : (
          <div className='d-flex align-items-center gap-2'>
            <button className='circle-btn' onClick={onDecrease}>
              -
            </button>
            <span>{value}</span>
            <div className='d-flex align-items-center gap-2'>
              <button className='circle-btn' onClick={onIncrease}>
                +
              </button>
              {mode === "edit" && (
                <img
                  src={bin}
                  alt='delete'
                  className='bin-icon'
                  style={{
                    width: "1.5rem",
                    height: "1.5rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleDeleteItem(selectedItemInCart)}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
